import { applicationConstants } from '../../../constants/applicationConstants';

export const getIsNew = application =>
  [
    applicationConstants.STATUS_NEW,
    applicationConstants.REVIEW,
    applicationConstants.STATUS_REPEAT
  ].includes(application.status);
